import React from "react";
import { Select, DatePicker } from "antd";
import FilterEndowType from "./FilterEndowType";
import useFetch from '../../../../commons/useFetch';
function Filter(props) {
  const getValueType = (filters) => {
    props.filterCheck(filters);
  };

  const { Option } = Select;
  const dateFormat = "DD-MM-YYYY";
const {data : hotels}=useFetch('https://610ec1597f793c00174195b7.mockapi.io/api/hotels')
  return (
    <div className="row filter">
      <div className="col-lg-3 col-12 ">
        <div className="formInput">
          <label>Hotels</label>
          <div className="formLocation">
            <Select
              onChange={(value) => props.onChangeHotels(value)}
              placeholder="Chọn khách sạn"
            >
              <Option>Tất cả khách sạn</Option>
              {hotels && hotels.map((option) => (
                <Option value={option.code} key={option.code}>
                  {option.name}
                </Option>
              ))}
            </Select>
          </div>
        </div>
      </div>
      <div className="col-lg-5 col-12 ">
        <div className="formInput">
          <label>Thời gian</label>
          <div className="row ">
            <div className="col-lg-6 col-12 date">
              <DatePicker
                onChange={(date, dateString) =>
                  props.onchangeFromDate(dateString)
                }
                name="arrivalDate"
                placeholder="Từ ngày"
                format={dateFormat}
              />
            </div>
            <div className="col-lg-6 col-12 date">
              <DatePicker
                onChange={(date, dateString) =>
                  props.onchangeToDate(dateString)
                }
                name="departureDate"
                placeholder="Đến ngày"
                format={dateFormat}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="col-lg-4 col-12">
        <FilterEndowType
          handlFilterCheck={(filters) => getValueType(filters, "endowType")}
        />
      </div>
    </div>
  );
}
export default Filter;
